export default class ACLService {
  constructor(permissions) {
    // user permissions
    this.permissions = permissions;
  }

  /**
   * Logic untuk mengecek apakah user memiliki permission yg diberikan di parameter atau tidak.
   *
   * @param {string} name
   * @param {string} permission
   */
  hasPermission(permission) {
    let result = this.permissions.filter(item => {
      return item.permission === permission || permission === "all";
    });
    return result.length > 0;
  }

  /**
   * Untuk mengecek apakah name & permission yang diberikan ada di permissions User.
   * @param {array} permissions
   */
  hasPermissions(permissions) {
    const result = this.hasPermission(permissions.meta.permission);
    return result;
  }

  /**
   * Untuk mengecek parent menu. Apakah punya permissions dari children-nya atau tidak.
   *
   */
  checkParentPermissions(parentItem) {
    const { items: children } = parentItem;
    const filtered = children.filter(child => this.checkPermission(child));
    return filtered.length > 0;
  }

  /**
   * Logic untuk mengecek apakah object routing 'to' mempunyai permissions atau tidak.
   *
   * @param {object} to
   */
  checkRoutePermissions(to) {
    const acl = to;
    if (!acl) return true;
    return this.hasPermissions(to || []);
  }

  /**
   * Untuk mengecek apakah menu item mempunyai permissions atau tidak.
   *
   * @param {object} item
   */
  checkPermission(item) {
    return this.hasPermissions(item.meta);
  }
}
